<template>
    <div id="stage-auth">
        <div class="header mt-5">
            <b class="text-3xl"> Etapa de Criação do Domínio em Nossos Serviços </b>
        </div>
   
        <div class="body mt-5">
            <div class="flex mb-5">
                <p class="align-self-center"> A primeira etapa para <strong> autenticar seu domínio </strong> e <strong> habilita-lo para disparar campanhas via email </strong> é adicionar o seu nome de domínio em nossos serviços. 
                    Não se esqueça que você só deve autenticar seu domínio <strong> caso você tenha um domínio corporativo vinculado ao seu email </strong>.
                    Por favor, <strong> insira seu domínio </strong> no campo abaixo:
                </p>
            </div>
            <div class="flex">
                <vs-input  icon="mode_edit" class="w-full" v-model="domainName"> Nome do domínio </vs-input>
            </div>
        </div>
    </div>
   </template>
   
<script>

export default {
    name: 'CreateDomain',
    data() {
        return {
            domainName: ''
        }
    },
    props: {
        getDomainName: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'setName'
    ],
    watch: {
        getDomainName(value) {
            if (value) this.$emit('setName', this.domainName);
        }
    }
}
</script>

   <!--

     <div class="body mt-5">
      <div class="flex">
       <feather-icon icon="LockIcon" svgClasses="w-5 h-5" class="p-5"/>
       <p class="align-self-center">Você deverá acessar seu sistema de <strong>host de domínios</strong> e criar dois novos <strong>registros DNS do tipo TXT.</strong></p>
      </div>
      <div class="flex">
       <feather-icon icon="MousePointerIcon" svgClasses="w-5 h-5" class="p-5"/>
       <p class="align-self-center">Após a criação na etapa <strong>Informações de Configuração DNS</strong> você terá as informações dos dados que devem ser inseridos nos <strong>DNSs</strong> criados.</p>
      </div>
      <div class="flex">
       <feather-icon icon="Share2Icon" svgClasses="w-5 h-5" class="p-5"/>
       <p class="align-self-center">Haverá um <strong>código Brevo</strong> e um <strong>registro DKIM</strong> que servirão para você confirmar que é dono do domínio que está configurando e ter total autonomia para disparar e criar seus remetentes de e-mails.</p>
      </div>



   -->